const outputConfig = {
    mtextFontInherit: true,
    // LCMS uses `linebreaks: { automatic: true },`. That might work for them because their tables' columns have
    // dynamic width which isn't determined by the cells' contents. As our columns' width is determined by the
    // content's width, the default value of automatic: false will work for this project. [[Docs](https://docs.mathjax.org/en/v2.7-latest/options/output-processors/HTML-CSS.html)]
    linebreaks: { automatic: false },
    fonts: ['TeX'],
}

export const MATHJAX_2_CONFIG = {
    showMathMenu: false,
    messageStyle: 'none',
    extensions: [
        'mml2jax.js',
        'tex2jax.js',
        'asciimath2jax.js',
        'MathMenu.js',
        'MathZoom.js',
        'AssistiveMML.js',
        'a11y/accessibility-menu.js',
    ],
    jax: [
        'input/MathML',
        'input/TeX',
        'input/AsciiMath',
        'output/CommonHTML',
        'output/HTML-CSS',
    ],
    tex2jax: {
        inlineMath: [
            ['$', '$'],
            ['\\(', '\\)'],
        ],
        displayMath: [
            ['$$', '$$'],
            ['\\[', '\\]'],
        ],
        processEscapes: true,
    },
    CommonHTML: outputConfig,
    TeX: {
        extensions: [
            'AMSmath.js',
            'AMSsymbols.js',
            'mhchem.js',
            'noErrors.js',
            'noUndefined.js',
        ],
        equationNumbers: { autoNumber: 'AMS' },
        Macros: {
            n: '\\overline',
        },
    },
    HTML: ['input/TeX', 'output/CommonHTML', 'output/HTML-CSS'],
    'HTML-CSS': outputConfig,

    /**
     * Docs:
     * https://github.com/fast-reflexes/better-react-mathjax/#general-considerations-regarding-flashes-of-non-typeset-content
     * https://docs.mathjax.org/en/v2.7-latest/options/extensions/fast-preview.html
     * https://github.com/mathjax/MathJax/issues/2740#issuecomment-885596396
     */
    messageStyle: 'none',
    'fast-preview': { disabled: true },
}
